// src/pages/PSTUploadPage.js
import React from 'react';
import PSTUploadForm from '../components/PSTUploadForm';
import '../App.css';
import Header from '../components/Header';



const PSTUploadPage = () => (
    <>
    <Header />
    <div className="app-container">
      <div className="left-image">
        <img src="/image.png" alt="Invoices Illustration" />
      </div>
    <PSTUploadForm />
  </div>
  </>
);

export default PSTUploadPage;
